import axios from "axios";
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { ResponseRequest } from "components/Types/GeneralTypes";
import { alertService } from "components/Varios/alert_service";
import config from "config.json"
import { authHeaderWithToken, authHeaderWithUserData } from "helpers/auth-header";
import { authenticationService } from "services/authentication.service";
import { DetalleSolicitudReplanificacion, PostSolicitudMasivo, SolicitudesPorAprobar, SolicitudVacacionesRechazoDTO, TipoFiltroSolicitudAprobar } from "./TypesAprobacionSolicitudes";


const URL_CONTROLLER_ENTRADA_SALIDA = config.SERVER_URL + "RegistroEntradaSalida";


export async function ObtenerInformacionSolicitudes(tipo:TipoFiltroSolicitudAprobar) {
    const URL = config.SERVER_URL + (tipo !== undefined ? `RegistroEntradaSalida/GetInformacionTablaAprobaciones/${tipo}`:"Aprobacion")
    


    
    const datosUsuario: UserData = authenticationService.currentUserValue;
    var resultado: ResponseRequest = { status: -1 }
    try {
        const respuesta = await axios.get(URL,
            {
                headers: authHeaderWithUserData(datosUsuario)
            })
        const datos: SolicitudesPorAprobar[] | string = respuesta.data;

        if (typeof (datos) === "string") {
            resultado = { status: respuesta.status, dataResponse: datos }
        }
        else {
            const datosMapeados: SolicitudesPorAprobar[] = MapearSolicitudesPorAprobar(datos)
            resultado = { status: respuesta.status, dataResponse: datosMapeados }
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            resultado = { status: error.response.status, errorMessage: error.response.data }
        }

    }
    return resultado;
}

export function MapearSolicitudesPorAprobar(datos: SolicitudesPorAprobar[]) {
    const datosMapeados: SolicitudesPorAprobar[] = datos.map((val, ind) => {
        return {
            ...val,


            acciones: {
                estado: val.estado,
                tiposolicitud: val.tipoSolicitud,
                idSolicitud: val.idSolicitud,
                aprueba: val.aprueba,
                apruebanAmbos: val.apruebanAmbos,
                cantidadAprueba: val.cantidadAprueba,
                diaOrdinario: val.diaOrdinario,
                fechaDesde: val.fechaDesde,
                fechaHasta: val.fechaHasta,
                fechaVencimiento:val.fechaVencimiento,
                horaDesde: val.horaDesde,
                horaHasta: val.horaHasta,
                horasTotal: val.horasTotal,
                nombres: val.nombres,
                estadoParse: val.estadoParse,
                observacion: val.observacion,
                estadoString: val.estadoString,
                fechaReintegro: val.fechaReintegro,
                fechaSolicitud: val.fechaSolicitud,
                diasPendientes: val.diasPendientesVacaciones,
                nuevoSaldo: val.diasRestantesVacaciones,
                permisoCargoVacaciones: val.permisoCargoVacaciones,
                idTipoPermiso : val.idTipoPermiso,
                subTipo: val.subTipo,
                subTipoDescripcion:val.subTipoDescripcion
                


            }
        }
    })
    return datosMapeados
}


export async function AprobarParcialmenteSolicitudJustificacion(idSolicitud: number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    const URL = config.SERVER_URL + "RegistroEntradaSalida/DirectivoAprobador/AprobarParcialmente/" + idSolicitud;
    try {
        const respuesta = await axios.put(URL, {},
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        alertService.success("Se ha aprobado la solicitud");
        return 1;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            alertService.error(error.response.data);
        }
        return -1;
    }



}

export async function AprobarSolicitudJustificacion(idSolicitud: number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    const URL = config.SERVER_URL + "RegistroEntradaSalida/DirectivoAprobador/Aprobar/" + idSolicitud;
    
    try {
        const respuesta = await axios.post(URL, {},
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        alertService.success("La solicitud ha sido autorizada");
        return 1;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            alertService.error(error.response.data);
        }
        return -1;
    }



}

export async function RechazarSolicitudJustificacion(idSolicitud: number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    const URL = config.SERVER_URL + "RegistroEntradaSalida/DirectivoAprobador/Negar/" + idSolicitud;
    var resultado: ResponseRequest = { status: -1 }
    const datosRechazar: SolicitudVacacionesRechazoDTO = {
        Observacion:""
    }
    try {
        const respuesta = await axios.put(URL, datosRechazar,
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        resultado = { status: respuesta.status, dataResponse: respuesta.data }
        alertService.success("La solicitud no ha sido autorizada");
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            resultado = { status: error.response.status, errorMessage: error.response.data }
        }
        alertService.error(resultado.errorMessage);

    }

    return resultado;



}






export async function AprobarMasivaSolicitudes(listadoSolicitudes:SolicitudesPorAprobar[]){
    
    const infoUsuario: UserData = authenticationService.currentUserValue;

    const URL = config.SERVER_URL + "RegistroEntradaSalida/DirectivoAprobador/Aprobar/Masiva" ;

    const listadoIdSolicitudes:PostSolicitudMasivo[] = listadoSolicitudes.map((s,i) => {
        return {
            tipo:s.tipoSolicitud,
            aprueba:s.aprueba,
            idsolicitud:s.idSolicitud
        }
    })
    try {
        const respuesta = await axios.post(URL, {listadoSolicitudes:listadoIdSolicitudes},
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )

        const respuestaAprobacionMasiva:string[] = respuesta.data;
        
        if(respuestaAprobacionMasiva.length > 0){
            const mensajesProblemas = respuestaAprobacionMasiva.map((mensaje,indimensaje) => {
                return mensaje +"\n";
            })

            alertService.error(mensajesProblemas);
        }
        else{
            alertService.success("Todas las solicitudes fueron aprobadas.");

        }

        return 1;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            alertService.error(error.response.data);

            return -1;
        }

    }
}


export async function DirectivoAprobadorObtenerVistaPreviaFormularioJustificacion(idSolicitud: number, estado:string) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse: ResponseRequest = { status: -1 }

    var URL = `${URL_CONTROLLER_ENTRADA_SALIDA}/DirectivoAprobador/GetVistaPreviaFormularioGestion/${idSolicitud}/${estado}`;
    

    try {
        const respuesta = await axios.get(URL,
            {
                headers: authHeaderWithToken(infoUsuario.token),
                responseType: "blob"
            }
        )
        let url = window.URL.createObjectURL(respuesta.data);
        respuestaResponse = { status: respuesta.status, dataResponse: url }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            respuestaResponse = { status: error.response.status, errorMessage: mensaje }
        }
    }

    return respuestaResponse


}





